<template>
	<div id="wrapper" class="main-box">
		<div class="reg-box">
			<div class="step1" style="display: none">
				<div class="search-box-wrap">
					<div class="search-box">
						<input id="key" v-model="key" name="" placeholder="选择院校" >
						<span class="ico-clear" @click="searchClear"></span>
					</div>
				</div>
				<ul class="list-panel">
					<li class="item" v-for="school in keyList" @click="select(school)">{{school.name}}</li>
				</ul>
			</div>
			<div class="step2">
				<ul class="wx-list">
					<li id="btn_sel_school" :class="{'wx-link': !initSchool}">
						<label>院校</label>
						<input name="schoolId" type="hidden">
						<input v-model="schoolName" placeholder="请选择院校" @click="showSelect" readonly>
					</li>
					<li>
						<label>学号</label>
						<input v-model="staffNumber" placeholder="请输入学号" maxlength="20">
					</li>
					<li>
						<label>真实姓名</label>
						<input v-model="name" placeholder="请输入姓名" maxlength="10" >
					</li>
				</ul>
				<ul class="wx-list">
					<li>
						<label>手机号码</label>
						<input v-model="phone" type="tel" placeholder="请填写手机号码">
					</li>
					<li class="code-box">
						<label>验证码</label>
						<input v-model="code" type="tel" placeholder="短信验证码" maxlength="6" οninput="if(value.length>6)value=value.slice(0,6)">
						<div class="btn-code" @click="onGetCode">{{secondStr}}</div>
					</li>
				</ul>
				<div class="btn-commit btn-bottom-grey" @click="onSubmit">提交</div>
			</div>
		</div>
	</div>
</template>
<script>
	import * as reg from '../../../../static/js/user/reg.js';
	import * as cookieUtil from '@static/js/cookieUtil.js';
	export default{
		data(){
			return{
				telReg : /^(1)[0-9]{10}$/,
				list:'',
				keyList:[],
				schoolName:'',
				key:'',
				openId:'',
				headImgUrl:'',
				unionId:'',
				staffNumber:'',
				name:'',
				phone:'',
				schoolId:'',
				code:'',
				secondStr:"获取验证码",
				second:0,
				clock:'',
				isSumit : false,
				sign:{},
				initSchool : false
			}
		},
		methods:{
			searchClear : function(){
				this.key = '';
				this.change();
			},
			upSecond:function(){
				var _this = this;
				this.clock = setInterval(function(){
					_this.second--;	
					if(_this.second > 0){
						_this.secondStr = "再次获取("+_this.second+"秒)"
					}else{
						_this.second = 0; //重置时间
						_this.secondStr = "再次获取";
						clearInterval(_this.clock); //清除js定时器
					}
				}, 1000); //一秒执行一次
			},
			select:function(_this){
				this.schoolId = _this.id;
				this.schoolName = _this.name;
				$(".step1").hide();
				$(".step2").show();
			},
			showSelect:function(){
				if(this.initSchool){
					return;
				}
				$(".step1").show();
				$(".step2").hide();
				this.change();
			},
			onSubmit:function(){
				if(this.schoolId == ""){
					return weui.alert("请选择院校");
				}
				if(this.staffNumber == ""){
					return weui.alert("请输入学号");
				}
				if(this.name == ""){
					return weui.alert("请输入真实姓名");
				}
				if(this.phone == ""){
					return weui.alert("请输入手机号");
				}
				if(this.code == ""){
					return weui.alert("请输入验证码");
				}
				// if(this.phone.length != 11 && this.phone.substring(0,1) != 1){
				// 	return weui.alert("手机号格式错误");
				// }
				if (!this.telReg.test(this.phone)) {
					return weui.alert("手机号格式错误");
				}

				this.submit();
			},
			submit :function(){
				var _this = this;
				if(_this.isSumit){
					return;
				}
				_this.isSumit = true;
				_this.loading = weui.loading('正在提交');
				_this.$axios.post(_this.stuApiUrl + "/student/register", 
				_this.$qs.stringify({
					openId:_this.openId,
					pic:_this.headImgUrl,
					unionId:_this.unionId,
					staffNumber:_this.staffNumber,
					name:_this.name,
					phone:_this.phone,
					schoolId:_this.schoolId,
					code:_this.code,
				})).then(function (response) {
					_this.loading.hide();
					if(!response.data.success){
						_this.isSumit = false;
						return weui.alert(response.data.info);
					}
					
					_this.delCookie('SC_WX_USER_COOKIE');
					window.sessionStorage.setItem('SC_USER',JSON.stringify(response.data.user));
					//判断跳转页面
					var path = '/student/user/center';
					if(_this.sign != null && _this.sign.schoolId && _this.sign.coursewareId){
						path = '/student/user/sign/pc/' + _this.sign.schoolId + "/" + _this.sign.coursewareId;
						if(_this.sign.mac){
							path = '/student/user/sign/app/' + _this.sign.schoolId + "/"+_this.sign.mac+"/" + _this.sign.coursewareId;
						}
					}
					if(_this.join != null && _this.join.schoolId){
						path = '/student/user/join/class/' + _this.join.schoolId + "/" + _this.join.classId;
						if(_this.join.mac){
							path = '/student/user/join/group/' + _this.join.schoolId + "/"+_this.join.mac+"/" + _this.join.coursewareId;
						}
					}


					cookieUtil.delCookie('SC_SIGN');
					cookieUtil.delCookie('SC_JOIN');

					weui.toast('注册成功');
					_this.$axios.post(_this.apiUrl + "/auth/login", _this.$qs.stringify({userId: response.data.user.id})).then(function (response) {
						if(!response.data.success){//登录失败
							if(!response.data.errorcode){//用户不存在或者已删除
								cookieUtil.delCookie("SC_COOKIE_USER_ID");
								return _this.$router.replace('/auth');
							}
							return;
						}
						var url = cookieUtil.getCookie("SC_COOKIE_URL");
						url = decodeURIComponent(url);
						
						_this.user = response.data.user;
						window.sessionStorage.setItem("SC_USER",JSON.stringify(_this.user));
						cookieUtil.setCookieEXP('SC_COOKIE_USER_ID', _this.user.id, 3600);
						
						if(url && url.indexOf('scan') > -1){
							path = url;
						}

						_this.$router.replace(path);
					}).catch(function (error) {
						console.log(error);
					});
				}).catch(function (error) {
					_this.isSumit = false;
					_this.loading.hide();
				});
			},
			change:function(){
				this.keyList = [];
				for(var i = 0 ; i < this.list.length;i++){
					if(this.list[i].name.indexOf(this.key) != -1){
						this.keyList.push(this.list[i]);
					}
				}
			},
			onGetCode:function(){
				if(this.second > 0){
					return;
				}
				if(!this.phone){
					return weui.alert("请输入手机号");
				}
				if(this.phone.length != 11 && this.phone.substring(0,1) != 1){
					return weui.alert("手机号格式错误");
				}
				// if (!this.telReg.test(this.phone)) {
				// 	return weui.alert("手机号格式错误");
				// }
        reg.getVCode(this, ()=>{
          this.second = 60;
          this.upSecond();
        });
			},
			loadData:function(){
				var _this = this;
				_this.loading = weui.loading('正在加载');
				_this.$axios.post(_this.stuApiUrl + "/school/list",_this.$qs.stringify({}))
			    .then(function (response) {
					_this.loading.hide();
			    	if(!response.data.success){
			    		return weui.alert(response.data.info);
                    }
					_this.list = response.data.school;

					if(_this.list.length == 1){
						_this.schoolId = _this.list[0].id;
						_this.initSchool = true;
					}

					if(_this.schoolId){
						for(var index in _this.list){
							var item  = _this.list[index];
							if(item.id == _this.schoolId){
								_this.schoolName = item.name;
								break;
							}
						}
					}
					if(!_this.schoolName){
						_this.schoolId = null;
					}
			    }).catch(function (error) {
					console.log(error);
					_this.loading.hide();
					weui.alert(error);
			    });	
            },
            initEvent : function(){
                var _this = this;
				$('#wrapper').on('input', '#key', _this.change);
				$('#wrapper').on('blur', 'input', function(event){
                    window.scrollTo(0, 0)
                });
            },
            delCookie:function(_this){
            	cookieUtil.delCookie(_this);
            }
		},
		mounted(){
			var cookieObj = cookieUtil.getCookie("SC_WX_USER_COOKIE");
			if(null != cookieObj){
				var cookie = JSON.parse(cookieObj);
				this.openId = cookie.openId;
				this.headImgUrl = cookie.headImgUrl;
				this.unionId = cookie.unionId;
				// this.delCookie('SC_WX_USER_COOKIE');
			}
			var height = $('.main-box').height();
			$('.main-box').height(height);
			
            this.initEvent();
			this.loadData();
			
			var signObj = cookieUtil.getCookie("SC_SIGN");
			var sign = null;
			var join = null;
			if(signObj && null != signObj && signObj != 'null' && signObj != 'undefined') {
				signObj = decodeURIComponent(signObj)
				sign = JSON.parse(signObj);
			}
			var joinObj = cookieUtil.getCookie("SC_JOIN");
			if(joinObj && null != joinObj && joinObj != 'null' && joinObj != 'undefined') {
				joinObj = decodeURIComponent(joinObj)
				join = JSON.parse(joinObj);
			}

			var schoolId = 0;
			if(sign){
				schoolId = sign.schoolId;
				this.sign = sign;
			}
			if(join){
				schoolId = join.schoolId;
				this.join = join;
			}
			if(schoolId){
				this.schoolId = schoolId;
				this.initSchool = true;
			}
			// cookieUtil.delCookie('SC_SIGN');
			// cookieUtil.delCookie('SC_JOIN');
		},
		beforeDestroy(){
		},
		destroyed(){
			clearInterval(this.clock);
		}
	}
</script>
<style scoped>
.main-box{
	min-height: 100vh;
	padding-bottom: 1rem;
	box-sizing: border-box;
	overflow: hidden;
	position: relative;
}
.main-box .reg-box{
	height: 100%;
	overflow: auto;
}
.search-box-wrap{
    padding: .22rem;
    background-color: #EDEDEF;
}
.search-box{
    width: 100%;
    background-color: #ffffff;
    line-height: .94rem;
    padding-left: .86rem;
    padding-right: .3rem;
    background-image: url("../../../../static/images/search@3x.png");
    background-size: .3rem .3rem;
    background-position: .3rem center;
    background-repeat: no-repeat;
    border-radius: .05rem;
	position: relative;
}
.search-box input{
    border: none;
    line-height: .94rem;
    padding-right: .6rem;
    box-sizing: border-box;
    width: 100%;
    background-size: .3rem .3rem;
    background-position: right center;
    background-repeat: no-repeat;
}

.search-box input:focus{
    background-image: url("../../../../static/images/dele_s@2x.png");
}

.search-box .ico-clear{
	width: .9rem;
	height: .94rem;
	position: absolute;
	right: 0;
	bottom: 0;
}

.search-box .list-panel{
    background-color: #fff;
    padding-left: 1.08rem;
    border-bottom: 01px solid #edeef2;
}

.search-box .list-panel li{
    line-height: .92rem;
    font-size: .3rem;
    color: #b8bacc;
    border-bottom: 01px solid #edeef2;
    text-align: left;
}

.search-box .list-panel li:last-child{
    border-bottom: 0;
}





.wx-list {
    padding-left: 0.34rem;
    box-sizing: border-box;
    border-bottom: 0.01rem solid #EDEEF2;
    margin: 0 0 0.2rem 0;
    background-color: #fff;
    font-size: .3rem;
}

.wx-list > li {
    height: 1.2rem;
	box-sizing : border-box;
    border-bottom: 0.01rem solid #EDEEF2;
	padding: .29rem .7rem .29rem 0;
    text-align: left;
}

.wx-list > li:last-child {
    border: none;
}

.wx-list > li.wx-link {
    background-image: url("../../../../static/images/teacher/teacher_more@2x.png");
    background-size: .12rem .24rem;
    background-position: right 0.1rem center;
    background-repeat: no-repeat;
}

.wx-list > li label {
	height: .6rem;
	line-height: .6rem;
    color: #b8bacc;
	float: left;
}

.wx-list li.code-box label{
    display: inline-block;
    width: 1.1rem;
    text-align: left;
}


.wx-list li.code-box input{
    border: 0;
    width: 2rem;
    font-size: .3rem;
    float: none;
    display: inline-block;
	height: .6rem;
	line-height: .6rem;
	text-align: right;
}


.wx-list li.code-box .btn-code{
    text-align:right;
    border-left: 01px solid #EDEEF2;
    float: right;
    width: 2.45rem;
	height: .6rem;
	line-height: .6rem;
	color: #03BBB5;
}


.wx-list li input{
    border: none;
    float: right;
    max-width: 3rem;
    line-height: .6rem;
	height: .6rem;
    color: #000;
    text-align: right;
    font-size: .3rem;
	vertical-align: top;
}

.btn-commit{
	margin: auto;
	margin-top: .6rem;
}

</style>


// WEBPACK FOOTER //
// src/components/student/user/reg.vue